import { Injectable } from '@angular/core';
import { ActionFactory, ConditionFactory } from '.';
import { Options } from '../models';
import { IAction } from '../interfaces';
import { CloseInvitationAction, EnableButtonAction, ShowProactiveChatAction } from '../common/actions';

@Injectable({
    providedIn: 'root'
})
export class ActionService {

    private actions: IAction[];

    constructor(
        private actionFactory: ActionFactory,
        private conditionFactory: ConditionFactory
    ) {
        this.actions = [];
    }

    init(applicationOptions: Options): void {
        if (applicationOptions.Actions) {
            this.actions = applicationOptions.Actions.map(a => {
                const action = this.actionFactory.getAction(a.Name);

                if (!a.Conditions) {
                    console.log(`${a.Name} action has not been configured with any conditions`);
                    return action;
                }

                a.Conditions.forEach(c => {
                    const condition = this.conditionFactory.getCondition(c.Name, applicationOptions, c.Options);
                    action.addCondition(condition);
                });

                console.log(`${a.Name} action is loaded with ${a.Conditions.length} condition(s)`);
                return action;
            });
        }
    }

    start(): void {
        const enableButtonAction = this.actions.find(a => a instanceof EnableButtonAction);
        if (enableButtonAction) {
            enableButtonAction.invoke();
        }

        const showProactiveChatAction = this.actions.find(a => a instanceof ShowProactiveChatAction);
        if (showProactiveChatAction) {
            const closeInvitationAction = this.actions.find(a => a instanceof CloseInvitationAction);
            if (closeInvitationAction) {
                showProactiveChatAction.nextAction = closeInvitationAction;
            }
            showProactiveChatAction.invoke();
        }
    }

    cancelAll(): void {
        this.actions.forEach(action => action.cancel());
    }

    cancelCloseInvitation() {
        const action = this.actions.find(a => a instanceof CloseInvitationAction);
        if (action) {
            action.cancel();
        }
    }
}
